
import React, { useEffect, useState } from 'react';

const ModernComingSoon = () => {
  const [loadingProgress, setLoadingProgress] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setLoadingProgress(prev => {
        if (prev >= 100) return 0;
        return prev + 1;
      });
    }, 50);

    return () => clearInterval(timer);
  }, []);

  return (
    <div className="container">
      {/* Animated background gradient */}
      <div className="background-gradient"></div>
      
      {/* Background Image */}
      <div className="background-image"></div>
      
      {/* Floating particles */}
      <div className="particles">
        {[...Array(20)].map((_, i) => (
          <div
            key={i}
            className="particle"
            style={{
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`,
              animation: `float ${5 + Math.random() * 10}s linear infinite`,
              animationDelay: `-${Math.random() * 5}s`
            }}
          />
        ))}
      </div>

      {/* Main content */}
      <div className="content">
        {/* Loading dots animation */}
        <div className="loading-dots">
          <span>●</span>
          <span>●</span>
          <span>●</span>
        </div>

        <h1 className="title">Coming Soon</h1>

        {/* Modern loading bar */}
        <div className="loading-bar-container">
          <div className="loading-bar">
            <div 
              className="loading-progress"
              style={{ width: `${loadingProgress}%` }}
            />
          </div>
          <div className="loading-text">
            Loading... {loadingProgress}%
          </div>
        </div>

        {/* Glowing text */}
        <p className="subtitle">
          We're crafting something extraordinary
        </p>

        {/* Animated rings */}
        <div className="rings">
          {[...Array(3)].map((_, i) => (
            <div
              key={i}
              className="ring"
              style={{
                width: `${(i + 1) * 200}px`,
                height: `${(i + 1) * 200}px`,
                animation: `ripple 6s ease-out infinite ${i * 2}s`
              }}
            />
          ))}
        </div>
      </div>

      <style jsx>{`
        .container {
          min-height: 100vh;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          position: relative;
          background-color: black;
          overflow: hidden;
        }

        .background-image {
          position: absolute;
          inset: 0;
          background-image: url('https://www.b2eautomation.com/content/solar-power-robot-automation.png');
          background-size: cover;
          background-position: center;
          opacity: 0.3;
          z-index: 1;
        }

        .background-gradient {
          position: absolute;
          inset: 0;
          background: linear-gradient(to bottom right, #4a1d96, #000000, #1e3a8a);
          opacity: 0.5;
          animation: gradientShift 8s ease infinite;
          z-index: 2;
        }

        .particles {
          position: absolute;
          inset: 0;
          z-index: 3;
        }

        .particle {
          position: absolute;
          height: 8px;
          width: 8px;
          background-color: white;
          border-radius: 50%;
          opacity: 0.2;
        }

        .content {
          position: relative;
          z-index: 4;
          text-align: center;
          padding: 0 1rem;
        }

        .loading-dots {
          margin-bottom: 2rem;
          color: #3b82f6;
          font-family: monospace;
        }

        .loading-dots span {
          display: inline-block;
          margin: 0 2px;
        }

        .loading-dots span:nth-child(1) { animation: bounce 1s ease-in-out infinite; }
        .loading-dots span:nth-child(2) { animation: bounce 1s ease-in-out 0.2s infinite; }
        .loading-dots span:nth-child(3) { animation: bounce 1s ease-in-out 0.4s infinite; }

        .title {
          font-size: 4.5rem;
          font-weight: bold;
          background: linear-gradient(to right, #3b82f6, #8b5cf6);
          -webkit-background-clip: text;
          background-clip: text;
          color: transparent;
          animation: slideDown 1s ease-out;
          margin-bottom: 3rem;
        }

        .loading-bar-container {
          max-width: 28rem;
          margin: 0 auto;
          margin-bottom: 3rem;
        }

        .loading-bar {
          height: 4px;
          width: 100%;
          background-color: #1f2937;
          border-radius: 9999px;
          overflow: hidden;
          margin-bottom: 0.5rem;
        }

        .loading-progress {
          height: 100%;
          background: linear-gradient(to right, #3b82f6, #8b5cf6);
          transition: width 100ms ease-out;
        }

        .loading-text {
          color: #9ca3af;
          font-family: monospace;
          font-size: 0.875rem;
        }

        .subtitle {
          font-size: 1.25rem;
          color: #d1d5db;
          max-width: 42rem;
          margin: 0 auto;
          animation: pulse 3s ease-in-out infinite;
        }

        .rings {
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
          z-index: -1;
        }

        .ring {
          position: absolute;
          border-radius: 50%;
          border: 1px solid rgba(59, 130, 246, 0.2);
        }

        @keyframes bounce {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(-10px); }
        }

        @keyframes gradientShift {
          0%, 100% { transform: scale(1.1) rotate(0deg); }
          50% { transform: scale(1) rotate(3deg); }
        }

        @keyframes float {
          0% { transform: translate(0, 0); }
          50% { transform: translate(20px, 20px); }
          100% { transform: translate(0, 0); }
        }

        @keyframes ripple {
          0% { transform: scale(0.8); opacity: 0; }
          50% { transform: scale(1); opacity: 0.3; }
          100% { transform: scale(1.2); opacity: 0; }
        }

        @keyframes slideDown {
          from {
            opacity: 0;
            transform: translateY(-50px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes pulse {
          0%, 100% { opacity: 1; }
          50% { opacity: 0.7; }
        }
      `}</style>
    </div>
  );
};

export default ModernComingSoon;